<div class="d-flex justify-content-between">
  <!--Add-->
  @if (addBtnVisible) {
    <button
      type="button"
      class="btn btn-outline-success btn-sm ag_grid_row_btn form-control py-0"
      tooltip="Add New User"
      placement="right"
      (click)="addClick()"
      >
      <i class="fa-solid fa-plus"></i>
    </button>
  }

  <!--Edit-->
  @if (editBtnVisible) {
    <button
      type="button"
      class="btn btn-outline-warning btn-sm ag_grid_row_btn form-control py-0"
      tooltip="Edit User"
      placement="right"
      (click)="editClick()"
      >
      <i class="fa-solid fa-pen"></i>
    </button>
  }

  <!--Delete-->
  @if (deleteBtnVisible) {
    <button
      type="button"
      class="btn btn-outline-danger btn-sm ag_grid_row_btn form-control py-0"
      style="margin-left: 2px; margin-right: 2px"
      tooltip="Delete User"
      placement="left"
      (click)="deleteClick()"
      >
      <i class="fa-solid fa-trash-can"></i>
    </button>
  }
</div>
